import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  getUserRightss,
  insertUserRights,
  deleteUserRightss,
  getUserRoles,
  insertUserRole,
  getPages,
} from "../../services/dataService";
import { data } from "jquery";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";

export default function UserRight() {
  const UID = getSecureItem("userId");
  //  ALL states
  const [userRoleData, setUserRoleData] = useState();
  const [addUserRightModal, setAddUserRightModal] = useState(false);
  const [editUserRightModal, setEditUserRightModal] = useState(false);
  const [userRights, setUserRights] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [UserRole, setUserRole] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [newUserRole, setNewUserRole] = useState("");
  const [haveUser, setHaveUser] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [UserRoleIdToDelete, setUserRoleIdToDelete] = useState(null);
  const [pages, setPages] = useState([]);

  const [userRightData, setUserRightData] = useState({
    Id: "",
    Name: userRoleData?.Name,
    UserroleId: "",
    PagesId: [],
    UserId: UID,
  });

  useEffect(() => {
    console.log("userRightData", userRightData);
  }, [userRightData]);

  const ClearData = () => {
    setUserRightData({
      Id: "",
      Name: userRoleData?.Name,
      UserroleId: "",
      PagesId: [],
      UserId: UID,
    });
  };

  const ClearDataedit = () => {
    console.log("hello");
    setUserRightData({
      ...userRightData,
      PagesId: [],
    });
  };

  const handleChangeCheck = (e) => {
    const { value, checked } = e.target;
    setUserRightData((prev) => {
      let updatedPagesId = [...prev.PagesId];
      if (checked) {
        updatedPagesId.push(value); // Add the page ID to the array
      } else {
        updatedPagesId = updatedPagesId.filter((id) => id !== value); // Remove the page ID
      }

      return {
        ...prev,
        PagesId: updatedPagesId,
      };
    });
  };

  const handleSelectAll = (e) => {
    const { checked } = e.target;

    if (checked) {
      // If "Select All" is checked, add all page IDs
      const allPagesIds = pages.map((page) => page.Id);
      setUserRightData((prev) => ({
        ...prev,
        PagesId: allPagesIds, // Set PagesId to include all IDs
      }));
    } else {
      // If "Select All" is unchecked, clear all page IDs
      setUserRightData((prev) => ({
        ...prev,
        PagesId: [], // Clear PagesId
      }));
    }
  };

  const openModal = (UserRoleId) => {
    setUserRoleIdToDelete(UserRoleId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setUserRoleIdToDelete(null);
  };

  const confirmDelete = () => {
    if (UserRoleIdToDelete) {
      removeUserRight(UserRoleIdToDelete);
    }
    closeModal();
  };

  useEffect(() => {
    console.log("userRightData.PagesId", userRightData.PagesId);
  }, [userRightData.PagesId]);

  useEffect(() => {
    const PageNames = data?.PageId?.map((pageId) => {
      const page = pages.find((item) => item.Id === pageId); // Find the page by ID
      return page ? page.Name : null; // Return the page name or null if not found
    });

    console.log("PageNames", PageNames); // Logs the array of page names
  }, [pages, data?.PageId]); // Run when `pages` or `data.PageId` changes

  useEffect(() => {
    console.log("ddd", userRightData);
  }, [userRightData]);

  useEffect(() => {
    const PageName = pages.find((item) => {
      if (item.Id == data?.pageId) {
        console.log(pages, "crProfit");
        console.log(item, "critem");
        return item?.Name;
      }
    });
    console.log("PageName", PageName);
  });

  const openAddUserRightModal = () => {
    setHaveUser(false);
    setNewUserRole("");
    setUserRightData({
      Id: "",
      Name: "",
      UserroleId: "",
      PagesId: [],
      UserId: UID,
    });
    setAddUserRightModal(!addUserRightModal);
  };
  const openEditUserRightModal = (data) => {
    // data.preventDefault()
    console.log("shahna", data);
    // profitcenter id name
    const CategoryName = UserRole.find((item) => {
      console.log("shahna2", item, "data", data);
      if (item.Id == data?.UserroleId) {
        console.log("shahna3", data);
        console.log(UserRole, "crProfit");
        console.log(item, "critem");
        return item?.Name;
      }
      console.log("shahna4");
    });

    console.log("shahna5", CategoryName);
    setUserRightData({
      ...data,
      UserroleId: data?.UserroleId,
      // DepartmentId: data.DepartmentId,
      CategoryName: CategoryName?.Name,
      // Department: DepartmentName?.Name,
      UserId: UID || "",
    });
    console.log("shahna6", editUserRightModal);
    setEditUserRightModal(!editUserRightModal);
  };

  // adding new user role
  const fetchUserRole = async () => {
    try {
      const response = await getUserRoles(UID);
      const resp = await getPages(UID);

      setPages(resp.data.data);
      setUserRole(response.data.data);
      setLoading(false);
      console.log(UserRole, "pro");
    } catch (error) {
      console.error("Error fetching Categorys:", error);
    }
  };

  useEffect(() => {
    fetchUserRole();
  }, []);
  // handleAddNewUserRole
  const handleAddNewUserRole = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await insertUserRole({
        Name: newUserRole,
        UserId: UID,
      });

      if (response?.data) {
        console.log(response.data, "rere");

        setUserRoleData(response?.data?.data[0]);

        setUserRightData((prevState) => ({
          ...prevState,
          UserroleId: response?.data?.data[0]?.Id,
        }));
        // toast.success("User Role added successfully");
        setNewUserRole("");

        setHaveUser(true);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      console.log(error, "eee");

      toast.error(error.response.data.error || "Failed to add User Role");
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
  }, []);

  useEffect(() => {
    if (userRights && userRights.length > 0) {
      const updatedData = userRights.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        UserroleId: item.UserroleId || "",
        UserId: item.UserId || "",
        PageNames: item.PageNames || "",
        PagesId: item.PageId || "",
        Role: UserRole.find((el) => el.Id === item.UserroleId)?.Name || "",
      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [userRights]);

  useEffect(() => {
    if (pages) {
      fetchUserRights();
    }
  }, [pages]);

  const fetchUserRights = async () => {
    try {
      const data = await getUserRightss(UID);
      console.log(data.data.data, "Fetched data");
      const updatedUserRights = data.data.data.map((userRight) => {
        const pageNames =
          userRight.PageId?.map((pageId) => {
            const page = pages.find((item) => item.Id === pageId);
            return page ? page.Name : null; // Return the page name or null if not found
          }) || [];

        // Add the corresponding page names to the userRight object
        return {
          ...userRight,
          PageId: Array.isArray(userRight.PageId)
            ? userRight.PageId
            : [userRight.PageId].filter(Boolean), // Ensure it's always an array
          PageNames:
            userRight.PageId?.map((pageId) => {
              const page = pages.find((item) => item.Id === pageId);
              return page ? page.Name : null;
            }) || [],
        };
      });
      console.log("updatedUserRights", updatedUserRights);

      setUserRights(updatedUserRights);
      setIsFilterVisible(false);
    } catch (error) {
      console.error("Error fetching userRights", error);
    }
    // setLoading(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (!userRightData.UserroleId) {
      setUserRightData((prevState) => ({
        ...prevState,
        UserroleId: userRoleData?.Id,
      }));
    } else if (userRightData.PagesId?.length <= 0) {
      toast.error("Please select Pages before submit");
      setLoading(false);
    } else {
      try {
        const response = await insertUserRights(userRightData);
        if (response) {
          console.log("dfghj", response);

          toast.success("User rights added successfully");
          fetchUserRole();
          fetchUserRights();
          openAddUserRightModal();
          // setLoading(false)
        }
        // setLoading(false)
      } catch (error) {
        toast.error(error);
        // setLoading(false)
      }
      // setLoading(false)
    }
  };
  // edit
  const handleEdit = async () => {
    setLoading(true);
    try {
      // Check if PagesId is empty
      if (userRightData.PagesId?.length <= 0) {
        toast.error("Please select Pages before Update");
        setLoading(false);
        return; // Stop further execution if condition is met
      }

      // Proceed with inserting/updating user rights
      const response = await insertUserRights(userRightData);

      // Check if the response is valid
      if (response) {
        toast.success("User Right Updated Successfully");
        fetchUserRights(); // Fetch updated user rights
        openEditUserRightModal(); // Open the modal again
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error editing userRight:", error);
      toast.error("An error occurred while updating user rights.");
      setLoading(false);
    }
  };

  // remove
  const removeUserRight = async (userRightId) => {
    try {
      const removeData = { Id: userRightId, TableName: "UserRight" };

      const res = await deleteUserRightss(removeData, UID);

      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("User Right deleted successfully");
          fetchUserRights();
        } else {
          toast.error("Unexpected response from the server.");
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting User Right.";
        toast.error("User Right already using cannot delete");
      } else {
        console.error("Error removing User Right:", error);
        toast.error("Error deleting User Right. Please try again.");
      }
    }
  };
  //
  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Role",
      selector: (row) => row.Role,
      sortable: true,
      selector: (row) => {
        const RollName = UserRole?.find((el) => el.Id === row.UserroleId);
        return RollName ? RollName.Name : "N/A";
      },
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditUserRightModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const filteredItems = dataFilter.filter((item) => {
    // If Role is not present in item, set it using UserRole.find()
    const role =
      item.Role || UserRole.find((el) => el.Id === item.UserroleId)?.Name || "";

    console.log(dataFilter, "dataFilter after filte"); // Logs the entire dataFilter array

    // Check if the role includes the filterText (case-insensitive)
    return role.toLowerCase().includes(filterText?.toLowerCase());
  });

  const subHeaderComponentMemo = useMemo(() => {}, [
    filterText,
    resetPaginationToggle,
  ]);

  const handleFilter = (filteredResults) => {
    console.log("filteredResults", filteredResults);

    const updatedResults = filteredResults.map((item) => ({
      ...item,
      PagesId: item.PageId, // Add PagesId to each object
    }));

    setDataFilter(updatedResults); // Update state with modified array
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {" "}
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this UserRight?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="User Rights" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Role"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button onClick={handleClear} className="btn btn-danger">
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button onClick={openAddUserRightModal} className="btn btn-primary">
            Add New
          </button>
        </div>
      </div>
      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={userRights}
          onFilter={handleFilter}
        />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {addUserRightModal && (
        <>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add UserRight
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddUserRightModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                <div className="grid grid-cols-12 gap-20">
                  {/* New User Role Input Field */}

                  {!haveUser && (
                    <>
                      <form
                        onSubmit={handleAddNewUserRole}
                        className="my-10 md:px-10 px-[7px] col-span-12 gap-2"
                      >
                        <div className="form-group flex col-span-12 flex-col gap-2">
                          <label>
                            Add User Role{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          <input
                            type="text"
                            id="newUserRole"
                            name="newUserRole"
                            placeholder="Enter New User Role"
                            value={newUserRole}
                            onChange={(e) => setNewUserRole(e.target.value)}
                            className="w-full px-3 py-2 border rounded-md mb-2"
                            required
                            // onBlur={(e) => {
                            //   setNewUserRole({ target: { name: "newUserRole", value: e.target.value.trim() } });
                            // }}
                          />
                        </div>

                        <div className="form-group flex col-span-12">
                          <button
                            type="submit"
                            // onClick={handleAddNewUserRole}
                            className="btn btn-secondary w-full"
                            disabled={loading}
                            // disabled={!newUserRole.trim()}
                          >
                            Add New User Role
                          </button>
                        </div>
                      </form>
                    </>
                  )}

                  {/* Existing UserRole Dropdown */}
                  {haveUser && (
                    <>
                      <div className="form-group flex col-span-12 flex-col gap-2">
                        <label>
                          User Role <span style={{ color: "red" }}>*</span>
                        </label>
                        <div>
                          <span>{userRoleData?.Name}</span>
                        </div>
                      </div>

                      <div className="form-group flex col-span-12 flex-col gap-2">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "16px",
                          }}
                        >
                          <label>
                            Pages <span style={{ color: "red" }}>*</span>
                          </label>
                          <div>
                            <input
                              type="checkbox"
                              checked={
                                pages.length > 0 &&
                                pages.every((center) =>
                                  userRightData.PagesId.includes(center.Id)
                                )
                              }
                              onChange={handleSelectAll}
                              required
                            />
                            Select All
                          </div>
                        </div>
                        <hr style={{ width: "50%" }}></hr>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3 , 1fr)",
                            gap: "16px",
                            marginTop: "16px",
                            marginBottom: "16px",
                          }}
                        >
                          {pages.map((center) => (
                            <div key={center.Id} className="flex ">
                              <input
                                type="checkbox"
                                id={center.Id}
                                value={center.Id}
                                checked={userRightData.PagesId.includes(
                                  center.Id
                                )}
                                onChange={handleChangeCheck}
                                style={{ marginRight: "8px", width: "16px" }}
                                required
                              />
                              <label htmlFor={center.Id}>{center.Name}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {haveUser && (
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    onClick={ClearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    onClick={handleSubmit}
                    className="btn btn-primary"
                    disabled={loading}
                    // disabled={loading|| userRoleData?.Id}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              )}
            </div>
          </div>
          <div
            // onClick={openAddUserRightModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
      {editUserRightModal && (
        <>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit User Right
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditUserRightModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                <div className="grid grid-cols-12 gap-20">
                  <div className="form-group flex col-span-12"></div>

                  <div className="form-group flex col-span-12">
                    <label className="text-sm font-medium border rounded px-2 py-1 bg-gray-100">
                      {UserRole.find(
                        (data) => data?.Id === userRightData?.UserroleId
                      )?.Name || userRightData?.CategoryName}
                    </label>
                  </div>
                  <div className="form-group flex col-span-12 flex-col gap-2">
                    <div
                      style={{
                        display: "col",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <label>
                        Pages <span style={{ color: "red" }}>*</span>
                      </label>

                      <div className="flex flex-row">
                        <span className="flex items-center gap-4 whitespace-nowrap">
                          <span>SelectAll</span>
                          <input
                            type="checkbox"
                            checked={
                              pages.length > 0 &&
                              pages.every((center) =>
                                userRightData?.PagesId?.includes(center.Id)
                              )
                            }
                            onChange={handleSelectAll}
                            className="ml-1"
                          />
                        </span>
                      </div>
                    </div>

                    <hr style={{ width: "50%" }} />
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: "16px",
                        marginTop: "16px",
                        marginBottom: "16px",
                      }}
                    >
                      {pages.map((center, index) => (
                        <div key={center.Id} className="flex">
                          <input
                            type="checkbox"
                            id={`page${index + 1}`}
                            name={`page${index + 1}`}
                            value={center.Id}
                            checked={userRightData.PagesId?.includes(center.Id)}
                            onChange={handleChangeCheck}
                            style={{ marginRight: "8px", width: "16px" }}
                            required
                          />
                          <label htmlFor={`page${index + 1}`}>
                            {center.Name}{" "}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                <button
                  type="button"
                  onClick={ClearDataedit}
                  className="btn btn-outline-secondary"
                >
                  Clear
                </button>
                <button
                  onClick={handleEdit}
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Update"}
                </button>
              </div>
            </div>
          </div>
          <div
            // onClick={openEditUserRightModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
